import React, {FC} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {H4, Body} from "@irati/ui/src/Typography"

import Field from "./Field"
import {RecapContainer, List} from "./styled"

interface Props {
  updateUsers?: boolean
  addUsers?: boolean
}
const FieldsRecap: FC<Props> = ({updateUsers, addUsers}) => (
  <RecapContainer>
    <H4>
      <FormattedMessage id="admin.components.addPeopleCSV.fieldsMapping.title" />
    </H4>
    <List>
      <Field
        label="admin.components.addPeopleCSV.fieldsMapping.firstName.label"
        description="admin.components.addPeopleCSV.fieldsMapping.firstName.description"
      />
      <Field
        label="admin.components.addPeopleCSV.fieldsMapping.lastName.label"
        description="admin.components.addPeopleCSV.fieldsMapping.lastName.description"
      />
      <Field
        label="admin.components.addPeopleCSV.fieldsMapping.email.label"
        description="admin.components.addPeopleCSV.fieldsMapping.email.description"
      />
      {(updateUsers || addUsers) && (
        <Field
          label="admin.components.addPeopleCSV.fieldsMapping.dateOfBirth.label"
          description="admin.components.addPeopleCSV.fieldsMapping.dateOfBirth.description"
          values={{
            date1: (
              <Body small weight="semibold" display="inline-block">
                <FormattedMessage id="admin.components.addPeopleCSV.fieldsMapping.dateOfBirth.date1" />
              </Body>
            ),
            date2: (
              <Body small weight="semibold" display="inline-block">
                <FormattedMessage id="admin.components.addPeopleCSV.fieldsMapping.dateOfBirth.date2" />
              </Body>
            )
          }}
        />
      )}
      {(updateUsers || addUsers) && (
        <Field
          label="admin.components.addPeopleCSV.fieldsMapping.employmentStartDate.label"
          description="admin.components.addPeopleCSV.fieldsMapping.employmentStartDate.description"
          values={{
            date: (
              <Body small weight="semibold" display="inline-block">
                <FormattedMessage id="admin.components.addPeopleCSV.fieldsMapping.dateOfBirth.date1" />
              </Body>
            )
          }}
        />
      )}
      {!updateUsers && (
        <Field
          label="admin.components.addPeopleCSV.fieldsMapping.team.label"
          description="admin.components.addPeopleCSV.fieldsMapping.team.description"
        />
      )}
      {!updateUsers && (
        <Field
          label="admin.components.addPeopleCSV.fieldsMapping.role.label"
          description="admin.components.addPeopleCSV.fieldsMapping.role.description"
        />
      )}
      <Field
        label="admin.components.addPeopleCSV.fieldsMapping.externalId.label"
        description="admin.components.addPeopleCSV.fieldsMapping.externalId.description"
      />
    </List>
  </RecapContainer>
)

export default FieldsRecap
